'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconXmarkCheck, iconXmarkCheckTag } from '@ni/nimble-components/dist/esm/icons/xmark-check';
import { wrap } from '../../utilities/react-wrapper';

export type { IconXmarkCheck };
export { iconXmarkCheckTag };
export const NimbleIconXmarkCheck = wrap(IconXmarkCheck);